const jezyk = { name: 'jezyk' }
export default jezyk